import { resolveSource } from './resolveSource.js';

export const buildDeleteFeedbackPayload = ({
  isMobileApp,
  platformId,
  feedbackReasons,
  feedbackDetails,
  profileId
}) => ({
  feedback_type: 'account_deletion',
  profile_id: profileId,
  source: resolveSource(isMobileApp, platformId),
  reason_codes: feedbackReasons.filter(fr => typeof fr === 'string'),
  comment: feedbackDetails,
  metadata: { campaign: 'gdpr_cleanup' }
});
